module.exports = __webpack_public_path__ + "static/media/galerija_2014 (4).1fb11ce0.jpg";